/**
 * CountryPostalFilter is the postal-code preference: 0 = US, 1 = Mexico.
 * https://developer.trimblemaps.com/restful-apis/location/geocoding-api/geocoding-batch/
 */
export const PCMILER_US_POSTAL_FILTER = 0;
export const PCMILER_MEXICO_POSTAL_FILTER = 1;

export type PcMilerZipCountry = {
  countryAbbreviation?: 'CA' | 'US' | 'MX';
  countryPostalFilter?:
    | typeof PCMILER_US_POSTAL_FILTER
    | typeof PCMILER_MEXICO_POSTAL_FILTER;
};

export type PcMilerZipLocation = {
  Address: {
    Zip: string;
    CountryAbbreviation?: 'CA' | 'US' | 'MX';
    CountryPostalFilter?:
      | typeof PCMILER_US_POSTAL_FILTER
      | typeof PCMILER_MEXICO_POSTAL_FILTER;
  };
};

export function pcMilerZipCountry(
  countryCode: string | null | undefined,
): PcMilerZipCountry {
  const code = (countryCode ?? '').trim().toUpperCase();
  if (code === 'MX' || code === 'MEX' || code === 'MEXICO') {
    return {
      countryPostalFilter: PCMILER_MEXICO_POSTAL_FILTER,
      countryAbbreviation: 'MX',
    };
  }
  if (code === 'US' || code === 'USA' || code === 'UNITED STATES') {
    return {
      countryPostalFilter: PCMILER_US_POSTAL_FILTER,
      countryAbbreviation: 'US',
    };
  }
  if (code === 'CA' || code === 'CAN' || code === 'CANADA') {
    return { countryAbbreviation: 'CA' };
  }
  return {};
}

export function buildPcMilerZipLocation(
  zip: string,
  countryCode?: string | null,
): PcMilerZipLocation {
  const country = pcMilerZipCountry(countryCode);
  const address: PcMilerZipLocation['Address'] = { Zip: zip };
  if (country.countryAbbreviation) {
    address.CountryAbbreviation = country.countryAbbreviation;
  }
  if (country.countryPostalFilter !== undefined) {
    address.CountryPostalFilter = country.countryPostalFilter;
  }
  return { Address: address };
}
